import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'

/**
 * @description
 * Guard to redirect from old 'fsqs' routes to new 'food-safety-iq' routes.
 * replaces 'fsqs' with 'food-safety-iq' in the URL and navigates to the new route.
 * If the URL does not start with 'fsqs', navigation is allowed to proceed.
 *
 * @returns
 * returns false if a redirection occurs, true otherwise.
 */

@Injectable({ providedIn: 'root' })

export class FsqsRedirectGuard  {
  public constructor(private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const url = route.url.map(segment => segment.path).join('/');
        if (url.startsWith('fsqs')) {
            const newUrl = url.replace('fsqs', 'food-safety-iq');
            const queryParams = route.queryParams;
            void this.router.navigate([`/${newUrl}`], { queryParams });
            return false;
        }
        // Allow navigation otherwise
        return true;
    }
}